import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["addResourceBundle"];
import { useTranslation as _useTranslation } from '@crehana/i18n';
import { COMPONENT_KEY } from "../constants";
import locales from "../i18n";
export var useTranslation = function useTranslation() {
  var _useTranslation2 = _useTranslation(COMPONENT_KEY),
    addResourceBundle = _useTranslation2.addResourceBundle,
    translationContextValue = _objectWithoutProperties(_useTranslation2, _excluded);
  addResourceBundle(locales);
  return translationContextValue;
};